import CIMSTable from 'components/CIMSTable'
import { useDisciplinesTableContext } from '../../DisciplinesTableContext'
import { useColumns } from './hooks/useColumns'
import { useCreate } from './hooks/useCreate'
import { useEdit } from './hooks/useEdit'
import { useExpand } from './hooks/useExpand'
import { useRemove } from './hooks/useRemove'
import { HelpMessage } from 'utils/constants'
import { useRestore } from './hooks/useRestore'

export const DisciplinesTable: React.FC = () => {
  const { records, refetch, fetching } = useDisciplinesTableContext()

  return (
    <CIMSTable
      rowKey={'id'}
      loading={fetching}
      records={records}
      columns={useColumns()}
      details={HelpMessage.DesignSubmittals.Disciplines.Details}
      actions={{
        header: {
          create: useCreate(),
          onReload: refetch,
        },
        row: {
          edit: useEdit(),
          remove: useRemove(),
          restore: useRestore(),
        },
      }}
      expand={useExpand()}
    />
  )
}
